var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,{tag:"component",class:[
    _vm.base[("horizontal" + _vm.gutterX)],
    _vm.base[("vertical" + _vm.gutterY)],
    _vm.flush && _vm.base[("flushHorizontal" + _vm.gutterX)],
    _vm.flush && _vm.base[("flushVertical" + _vm.gutterY)]
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }